<template>
    <div>
        <div class="relative pt-6 pb-6 bg-white -mb-px">
            <input type="text" class="border border-black-10 rounded-full p-3 w-full" v-model="term" :placeholder="placeholder" />
        </div>
        <slot v-bind:search-methods="searchMethods" />
    </div>
</template>

<script>
export default {
    name: 'SearchableList',
    props: ['placeholder'],
    data() {
        var self = this;
        return {
            term: "",
            searchMethods: {
                matches (fields) {
                    if (self.term){
                        return fields.some((fld) => fld.toLowerCase().includes(self.term.toLowerCase()));
                    } else {
                        return true;
                    }
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/js/components/SearchableList.vue